import { render, staticRenderFns } from "./ExampleMode.vue?vue&type=template&id=3b6c9d4a&"
import script from "./ExampleMode.vue?vue&type=script&lang=js&"
export * from "./ExampleMode.vue?vue&type=script&lang=js&"
import style0 from "./ExampleMode.vue?vue&type=style&index=0&id=3b6c9d4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports